import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import editing from '../../../assets/images/editing.svg';
import { ImageUpload } from '../../../shared/ImageUplader';
import { getStudentSignedUrl, studentProfileEdit } from '../../../Store/api/activities';

export default function PersonalInformation() {
  const dispatch = useDispatch();
  const [err, setError] = useState(null);
  const [img, setImage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [pronouns, setPronouns] = useState(user.pronouns);
  const [location, setLocation] = useState(user.location);
  const [name, setName] = useState(user.firstName + ' ' + user.lastName);
  const [locationTimeZone, setLocationTimeZone] = useState(user.locationTimeZone);
  const inputRef = useRef(null);
  const nameInputRef = useRef(null);
  const pronounsInputRef = useRef(null);
  const locationInputRefs = useRef(null);
  const timezoneInputRefss = useRef(null);

  const handleSave = () => {
    // Call the API to update the profile
    const updatedProfile = {
      firstName: name.split(' ')[0],
      lastName: name.split(' ')[1],
      pronouns,
      location,
      locationTimeZone,
      image: img || user?.image || '',
    };

    dispatch(
      studentProfileEdit({
        body: updatedProfile,
        onSuccess: () => {
          setIsEditing(false);
        },
        onError: (error) => {
          if (error?.response?.data && error?.response?.data?.message) {
            setError(error.response.data.message);
          } else {
            setError('Something went wrong while uploading image.');
          }
        },
      })
    );
  };

  useEffect(() => {
    if (isEditing) {
      // Focus the corresponding input field based on the active editing field
      nameInputRef?.current?.focus?.();
    }
  }, [isEditing]);

  const focusInput = () => {
    if (isEditing) {
      inputRef?.current?.focus?.();
    }
  };

  const uploadImage = async (file, signedUrl, imgUrl) => {
    try {
      await axios.put(signedUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      });
      setImage(imgUrl);
    } catch (error) {
      if (error?.response?.data && error?.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError('Something went wrong while uploading image.');
      }
    }
  };

  const fetchSignedUrl = (file) => {
    dispatch(
      getStudentSignedUrl({
        body: { fileType: file.type },
        onSuccess: (res) => {
          uploadImage(file, res.url, res.key);
        },
        onError: (error) => {
          if (error.response.data && error.response.data.message) {
            setError(error.response.data.message);
          } else {
            setError('Something went wrong while creating signed url.');
          }
        },
      })
    );
  };

  return (
    <div className='box_border_settings border-grey'>
      <div className='settings_header'>
        <h2>personal information</h2>
        <div className='settings_header'>
          <p
            className='mb-0 editt cursor'
            onClick={() => {
              setIsEditing(true);
              focusInput();
              setImage('');
              // err && setError(null);
            }}
          >
            {isEditing ? 'editing' : 'edit'}
          </p>
        </div>
      </div>
      <div className='setting_rows'>
        <p className='key'>Name</p>

        <p className='value'>
          {isEditing ? (
            <>
              <input
                type='text'
                value={name}
                onChange={(e) => setName(e.target.value)}
                ref={nameInputRef}
              />

              <img src={editing} alt='' onClick={() => nameInputRef.current.focus()} />
            </>
          ) : (
            <p>
              <span>{name}</span>
            </p>
          )}
        </p>
      </div>
      <div className='setting_rows'>
        <p className='key'>Pronouns</p>
        <p className='value'>
          {isEditing ? (
            <>
              <input
                type='text'
                value={pronouns}
                onChange={(e) => setPronouns(e.target.value)}
                ref={pronounsInputRef}
              />
              <img src={editing} alt='' onClick={() => pronounsInputRef.current.focus()} />
            </>
          ) : (
            <span>{pronouns}</span>
          )}
        </p>
      </div>
      <div className='setting_rows'>
        <p className='key'>Location</p>
        <p className='value'>
          {isEditing ? (
            <>
              <input
                type='text'
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                ref={locationInputRefs}
              />
              <img src={editing} alt='' onClick={() => locationInputRefs.current.focus()} />
            </>
          ) : (
            <span>{location}</span>
          )}
        </p>
      </div>
      <div className='setting_rows'>
        <p className='key'>Location Timezone</p>
        <p className='value'>
          {isEditing ? (
            <>
              <input
                type='text'
                value={locationTimeZone}
                ref={timezoneInputRefss}
                onChange={(e) => setLocationTimeZone(e.target.value)}
              />
              <img src={editing} alt='' onClick={() => timezoneInputRefss.current.focus()} />
            </>
          ) : (
            <span>{locationTimeZone}</span>
          )}
        </p>
      </div>
      <div className='setting_rows'>
        <p className='key'>Profile Picture</p>
        <p className='value'>
          <span className='profilePicture'>
            {isEditing ? (
              <>
                <ImageUpload imageUrl={img || user?.image || ''} fetchSignedUrl={fetchSignedUrl} />
              </>
            ) : user?.image ? (
              <img
                src={user.image}
                alt='profile_photo'
                style={{ width: '35px', height: '35px', objectFit: 'cover' }}
              />
            ) : user && user.firstName && user.lastName ? (
              user.firstName[0] + user.lastName[0]
            ) : (
              ''
            )}
          </span>
        </p>
      </div>
      {isEditing && (
        <div className='setting_rows' style={{ marginBottom: '0px' }}>
          <p className='key'></p>
          <p className='value'>
            <p className='main_part' style={{ color: 'red' }}>
              {err && err}
            </p>
            <p className='edit_buttton cursor' onClick={handleSave}>
              <span>Save --&gt;</span>
            </p>
          </p>
        </div>
      )}
    </div>
  );
}
